import React, {useState, useEffect, useRef, useContext} from "react";
import ekia from "../../../assets/images/ekia.png";
import Modal from "react-bootstrap/Modal";
import {BiSearch} from "react-icons/bi";
import {HiOutlineLogin} from "react-icons/hi";
import {SlBasket} from "react-icons/sl";
import {FiMenu, FiPhone} from "react-icons/fi";
import {VscCircleFilled} from "react-icons/vsc";
import {BiChevronLeft} from "react-icons/bi";
import {BiCurrentLocation} from "react-icons/bi";
import {IoMdClose} from "react-icons/io";
import SearchDropSwiper from "./SearchDropSwiper";
import MenuDropDown from "../MenuDropDown";
import Container from "../../LogIn/Container.jsx";
import "./header.css";

import {Link, NavLink, useNavigate} from "react-router-dom";
import WithAuthenticationContext from "context/Authentication/AuthenticationContext.ts";
import CardItemContext from "context/CardItem/CardItemContext";
import WebInfoContext from "context/WebInfo/WebInfoContext.ts";

import Basket from "./Basket";
import useAxios from "services/useAxios.tsx";
import {debounce} from "lodash";

const Header = ({active, back}) => {
    const {execute: searchApi} = useAxios("api3/search");
    const {userInfo, isLogged, auth} = useContext(WithAuthenticationContext);
    const {setShowOffcanvas, itemCount} = useContext(CardItemContext);
    const {searchQuery, setSearchQuery} = useContext(WebInfoContext);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [loginShow, setLoginShow] = useState(false);
    const [products, setProducts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [articles, setArticles] = useState([]);

    const callApiSearch = (query) => {
        let data = {};
        data.title = query;
        data.page = 1;
        data.count = 6;

        // Make your API call using the search query
        searchApi(data).then((res) => {
            setProducts(res.products.slice(0, 10));
            setCategories(res.hashtags.slice(0, 10));
            setArticles(res.post.slice(0, 10));
        });

        // Replace this console.log with your actual API call
    };
    const searchDebounce = useRef(
        debounce((text) => {
            callApiSearch(text);
        }, 2000)
    );
    useEffect(() => {
        callApiSearch("");
    }, []);


    function handleOutsideClick(event) {
        const digiSearchDrop = document.querySelector(".digi_search-drop");
        if (digiSearchDrop && !digiSearchDrop.contains(event.target)) active(false)
    }

    return (
        <header
            className="digi_header px-3"
            onClick={handleOutsideClick}
        >
            <div className="header_box mb-3">
                <div className="digi_Serachbox align-items-center">
                    <NavLink to="/">
                        <img
                            src={ekia}
                            className="mx-1"
                            style={{maxWidth: 180, maxHeight: 65}}
                        />
                    </NavLink>
                    <div
                        className="digi_search d-flex align-items-center me-3 "
                        onClick={() => active(true)}
                    >
                        <BiSearch color="#9e9fb1" size={20} className="search-icon"/>
                        <span
                            className="digi_search-text pe-4"
                            style={{fontSize: "11px"}}
                        >
              {searchQuery !== "" ? searchQuery : "جستجو"}
            </span>
                    </div>
                    {back == true && (
                        <div
                            className="digi_search-drop">
                            <div className="digi_search-inputbox mb-3">
                                <BiSearch
                                    color="black"
                                    size={20}
                                    className="search-drop-icon"
                                />
                                <input
                                    type="search"
                                    placeholder="جستجو"
                                    className="digi_search-input fs-11"
                                    onChange={(e) => {
                                        searchDebounce.current(e.target.value);
                                        setSearchQuery(e.target.value);
                                    }}
                                    autoFocus
                                />
                            </div>
                            {categories.length !== 0 ? (
                                <div>
                                    <div style={{fontSize: "15px", marginBottom: "5px"}}>
                                        دسته بندی ها:
                                    </div>
                                    <SearchDropSwiper
                                        active={active}
                                        data={categories}
                                        type={"category"}
                                        searchQuery={searchQuery}
                                    />
                                </div>
                            ) : (
                                <div
                                    style={{
                                        justifyContent: "center",
                                        display: "flex",
                                        fontSize: "16px",
                                    }}
                                >
                                    دسته بندی با این مشخصات یافت نشد
                                </div>
                            )}
                            <hr/>
                            {products.length !== 0 ? (
                                <div>
                                    <div style={{fontSize: "15px", marginBottom: "5px"}}>
                                        محصولات:
                                    </div>
                                    <SearchDropSwiper
                                        active={active}
                                        data={products}
                                        type={"product"}
                                        searchQuery={searchQuery}
                                    />
                                </div>
                            ) : (
                                <div
                                    style={{
                                        justifyContent: "center",
                                        display: "flex",
                                        fontSize: "16px",
                                    }}
                                >
                                    محصولی با این مشخصات یافت نشد
                                </div>
                            )}
                            <hr/>
                            {articles.length !== 0 ? (
                                <div>
                                    <div style={{fontSize: "15px", marginBottom: "5px"}}>
                                        مقالات:
                                    </div>
                                    <SearchDropSwiper
                                        active={active}
                                        data={articles}
                                        type={"article"}
                                        searchQuery={searchQuery}
                                    />
                                </div>
                            ) : (
                                <div
                                    style={{
                                        justifyContent: "center",
                                        display: "flex",
                                        fontSize: "16px",
                                    }}
                                >
                                    مقاله ای با این مشخصات یافت نشد
                                </div>
                            )}
                        </div>
                    )}
                </div>
                <div className="digi_login d-flex align-items-center">
                    {/* <div>
            <FiPhoneCall
              style={{
                width: 20,
                // height: 20,
                color: "#424750",
                cursor: "pointer",
                fontSize: "25px",
              }}
            />
          </div> */}
                    {isLogged == false ? (
                        <div
                            className="digi_login-box pointer p-2 me-3 "
                            onClick={() => {
                                setLoginShow(true);
                            }}
                        >
                            <HiOutlineLogin
                                size={23}
                                color="#3f4064"
                                className="me-2 cursor-pointer"
                            />
                            <span
                                className="pe-2 digi_log-in cursor-pointer"
                                onClick={() => {
                                    setLoginShow(true);
                                }}
                            >
                ورود
              </span>
                            <div className="digi_line ms-2"></div>
                            <span
                                className="ps-2 digi_register cursor-pointer"
                                onClick={() => {
                                    setLoginShow(true);
                                }}
                            >
                ثبت نام
              </span>
                        </div>
                    ) : (
                        <div
                            className="digi_login-box p-2 mr-l-8 pointer"
                            onClick={() => {
                                document
                                    .getElementById("footer-container")
                                    .scrollIntoView({behavior: "smooth", block: "nearest"});
                            }}
                        >
                            <span className="pe-2 font-12-400 text-nowrap">تماس با ما</span>
                            <FiPhone className="wh-14"/>
                        </div>
                    )}
                    <div className="digi_basket ps-4 pointer position-relative">
                        <SlBasket
                            size={20}
                            className="mx-1 "
                            onClick={(e) => setShowOffcanvas((prev) => !prev)}
                        />
                        <div
                            className="d-flex p-2 ms-2  align-items-center justify-content-center text-light rounded-pill position-absolute"
                            style={{
                                backgroundColor: "tomato",
                                width: 14,
                                height: 14,
                                fontSize: 12,
                                top: -3,
                                right: 3,
                            }}
                        >
                            {itemCount}
                        </div>
                    </div>
                </div>
            </div>
            <div className="digi_nav">
                <div className="digi_all-menus d-flex align-items-center">
                    <ul className="digi_menu-org">
                        <li className="digi_menu-item">
                            <FiMenu size={20} color="#3f4064"/>
                            <span className="pe-2 digi_cat fs-14">دسته بندی کالاها</span>
                            <MenuDropDown/>
                        </li>
                    </ul>
                    <ul className="digi_menus fs-11 ">
                        <li className="digi_menus-item  ms-3">
                            <VscCircleFilled size={15} color="black"/>
                            <span
                                className="pe-1 digi_menus-link fs-14"
                                onClick={() => {
                                    if (document.getElementById("box-store") != null) {
                                        document
                                            .getElementById("box-store")
                                            .scrollIntoView({behavior: "smooth", block: "nearest"});
                                    } else {
                                        window.location.href = "/category/0"
                                    }
                                }}
                            >
                فروشگاه
              </span>
                        </li>

                        <NavLink
                            style={{textDecoration: "none", color: "#000"}}
                            to={"/blog"}
                        >
                            <li className="digi_menus-item  ms-3">
                                <VscCircleFilled size={15} color="black"/>
                                <span className="pe-1 digi_menus-link fs-14">بلاگ / مجله</span>
                            </li>
                        </NavLink>

                        <li className="digi_menus-item  ms-3">
                            <VscCircleFilled size={15} color="black"/>
                            <span
                                className="pe-1 digi_menus-link fs-14"
                                onClick={() => {
                                    document
                                        .getElementById("footer-container")
                                        .scrollIntoView({behavior: "smooth", block: "nearest"});
                                }}
                            >
                تماس با ما
              </span>
                        </li>

                        <NavLink
                            style={{textDecoration: "none", color: "#000"}}
                            to={"/blog/post/1"}
                        >
                            <li className="digi_menus-item  ms-3">
                                <VscCircleFilled size={15} color="black"/>
                                <span className="pe-1 digi_menus-link fs-14">ضمانت و شرایط بازگشت کالا و وجه</span>
                            </li>
                        </NavLink>

                    </ul>
                    {/* <div className="digi_question me-4">
            <span>درباره ما</span>
            <span className="pe-3">ضمانت و شرایط بازگشت کالا و وجه</span>
          </div> */}
                </div>
                {/* <div className="digi_location" onClick={handleShow}>
          <GrLocation size={17} color="#3f4064" />
          <span className="pe-2">ارسال به استان گلستان, </span>
          <span>گرگان</span>
          <div className="digi_drop-location">
            <span>ارسال به استان گلستان , گرگان</span>
          </div>
        </div> */}
            </div>
            <div>
                <Modal show={show} onHide={handleClose} animation={false}>
                    <Modal.Body>
                        <div className="modal_citys">
                            <div className="modal_city-choose mb-4">
                                <span>انتخاب شهر</span>
                                <IoMdClose
                                    size={25}
                                    onClick={handleClose}
                                    className="city_chosse-icon"
                                />
                            </div>
                            <div className="modal_city-list">
                                <div className="modal_location mb-4">
                                    <BiCurrentLocation size={25} className="ms-2"/>
                                    <span>مکان یابی خودکار</span>
                                </div>
                                <div className="modal_city mb-4">
                                    <span>آذربایجان شرقی</span>
                                    <BiChevronLeft size={20}/>
                                </div>
                                <div className="modal_city mb-4">
                                    <span>آذربایجان شرقی</span>
                                    <BiChevronLeft size={20}/>
                                </div>
                                <div className="modal_city mb-4">
                                    <span>آذربایجان شرقی</span>
                                    <BiChevronLeft size={20}/>
                                </div>
                                <div className="modal_city mb-4">
                                    <span>آذربایجان شرقی</span>
                                    <BiChevronLeft size={20}/>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
            <Container loginShow={loginShow} setLoginShow={setLoginShow}/>
            <Basket/>
        </header>
    );
};

export default Header;
